import React from 'react'
import Switch from 'react-switch'
import './stylesIS.css'

export default function InputSwitch({ info, onChange, value }) {
  return (
    <div className='label-sw'>
      <span>{info}</span>
      <Switch title={value ? 'Desativar' : 'Ativar'} onChange={onChange} checked={value} />
    </div>
  )
}
